import type { IntegrationConnectionType } from '@/api/integration';

export type IntegrationDisplayStatus = 'active' | 'notConnected' | 'broken';

export const getIntegrationProviderDisplayStatus = (
  connections: IntegrationConnectionType[],
): IntegrationDisplayStatus => {
  if (!connections.length) {
    return 'notConnected';
  }

  if (connections.some((connection) => connection.status === 'inactive')) {
    return 'broken';
  }

  return 'active';
};
